// 流程状态
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'
import ProcessOperateDiv from './ProcessOperateDiv'

class ProcessStatusDiv extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.id,
        processId: this.props.processId,
    }

    componentDidMount = () => {
        this.doGetProcessStatus()
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessStatus = () => {
        const { id, processId } = this.state
        Tyan.doPostEvent({
            event: 'GetProcessStatus',
            data: { id, processId },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, processId } = this.state
        const { changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessStatus',
            data: { id, processId, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetProcessStatus()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcessStatus',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onRefresh, onClose } = this.props
        if (!this.bChanged()) {
            onRefresh && onRefresh()
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onRefresh && onRefresh()
            onClose && onClose()
        })
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.状态名称
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handleAddProcessOperate = () => {
        const { id, processId } = this.state
        const { changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessStatus',
            data: { id, processId, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    Tyan.pubForm.showDialog('流程操作设置', props => <ProcessOperateDiv {...props} id={0} ProcessStatusID={id} onRefresh={() => this.doGetProcessStatus()} />)
                }
            }
        })
    }

    fieldset基本信息 = () => {
        return [
            { _text: '状态名称', required: true, minWidth: '45%' },
            { _radio: '状态', require: true, optionName: '状态', minWidth: '45%', },
            { _text: '执行人', minWidth: '45%' },
            { _radio: '流程方式', minWidth: '45%' },
            { _select: '邮件模板',  minWidth: '45%' },
            { _radio: '删除操作', minWidth: '45%' },
            { _int: '排序',  minWidth: '45%' },
            { _checkbox: '编辑字段', minWidth: '95%', itemMinWidth: 180 },
            { _checkbox: '显示字段', minWidth: '95%', itemMinWidth: 180 },
        ]
    }

    fieldset流程操作 = () => {
        const { id } = this.state
        return [{
            _grid: '', name: '流程操作', rowNumbers: true, minRows: 3, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '操作名称', flex: 2 },
                { _text: '目标状态', flex: 5 },
                { _text: '是否自动触发', flex: 2 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessOperate, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('流程操作设置', props => <ProcessOperateDiv {...props} id={data.id} ProcessStatusID={id} onRefresh={() => this.doGetProcessStatus()} />)
            }
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                    { title: '流程操作', name: '基本信息', _fieldset: this.fieldset流程操作(), fullblock: true, docked: 'bottom' },
                ]}
        />
    }
}

export default connect()(ProcessStatusDiv)